<template>
  <div>
    <div class="text-xl font-black py-2">8. Email Review</div>

    <div class="pt-2">
      <div>Please confirm if these email addresses held on file are correct?</div>
      <hr class="border-b my-2">
      <div class="flex w-full items-center">
        <div class="py-2 w-1/3">Email</div>
        <div class="flex justify-start w-2/3 items-center px-8">
          <div class="px-2 w-1/5">Active</div>
          <div class="px-2 w-1/5">Microsoft Exchange</div>
          <div class="px-2 w-1/5">POP3</div>
          <div class="px-2 w-1/5">Receives Newsletter</div>
          <div class="px-2 w-1/5">Remove</div>
        </div>
      </div>
      <div v-for="(email, index) in review.emailStatus" :key="index">
        <review-email-status-component v-model="review.emailStatus[index]" :showMandatory="showMandatory"></review-email-status-component>
      </div>
      <hr class="border-b mr-8">
    </div>

    <div class="pt-4">
      <div class="text-green text-lg cursor-pointer" @click="addEmailStatus">+ Add additional staff email address</div>
    </div>
    <div class="pt-4">
      * NB POP3 email accounts should be transferred to 'Exchange' for:
      <ul class="list-disc list-inside">
        <li>Option to invite your colleagues to share your calendar, contacts, and email folders. This is by invitation only; no one will
        see your files unless you send a personal invitation.</li>
        <li>Increase your email storage to 50GB.</li>
        <li>Access to a user-friendly Outlook for Web interface.</li>
        <li>Manage your email across multiple devices.</li>
        <li>Greater mobiles phone devices support.</li>
        <li>Improved auto-responder options.</li>
        <li>Maximum single message size is 150MB.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
import ReviewEmailStatusComponent from '@/components/AnnualReview/ReviewEmailStatusComponent'
export default {
  components: { ReviewEmailStatusComponent, ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  },
  mounted () {
  },
  methods: {
    addEmailStatus () {
      var newEmailStatus = {
        'id': null,
        'review_id': this.review.id,
        'email': '',
        'is_active': null,
        'is_ms_exchange': null,
        'is_pop3': null,
        'receive_newsletter': null,
        'remove': null,
        'created_at': null,
        'updated_at': null
      }
      this.review.emailStatus.push(newEmailStatus)
    }
  }
}
</script>
